<template>
    <div>
        <div class="form-group">
            <label>Company</label>
            <input type="text" class="form-control" v-model="data.company">
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: [
        'data',
    ],
    data() {
        return {};
    },
};
</script>